exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody[data-v-7eb92ea0] {\n  font-family: 'Microsoft YaHei', sans-serif;\n}\n", ""]);

// exports
